module.exports = __webpack_public_path__ + "static/img/Abc_Games_Banner.c7d6f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Abc_Games_Banner.png
// module id = +2P3
// module chunks = 7